import { Modal, ModalProps } from "antd"
import { useTranslation } from "react-i18next"
import { useDeleteSubstitutionApplication } from "./queries"
import { ISubstitutionRequest } from "./types"

interface Props extends ModalProps {
  data?: ISubstitutionRequest
  onClose: () => void
}
const DeleteSubstitutionApplicationModal: React.FC<Props> = ({
  data,
  ...props
}) => {
  const { t } = useTranslation()
  const { mutate, isLoading } = useDeleteSubstitutionApplication(data?.id!, {
    meta: {
      type: "delete",
      entity: t("global.application", { count: 1 }),
      context: "female",
      count: 1,
    },
  })

  const onSubmit = () => {
    mutate(data?.proposition.id!, {
      onSettled() {
        props.onClose()
      },
    })
  }

  return (
    <Modal
      title={t("global.deleteX", {
        entity: t("global.application", { count: 1 }),
        count: 0,
      })}
      okType="danger"
      onOk={onSubmit}
      okText={t("global.delete")}
      confirmLoading={isLoading}
      onCancel={props.onClose}
      cancelText={t("global.cancel")}
      {...props}
    >
      <p style={{ marginTop: "var(--size-6)" }}>
        {t("assignations.delete_substitution_application_confirmation")}
      </p>
    </Modal>
  )
}

export default DeleteSubstitutionApplicationModal
